/**
 * @file 拉货宝模块路由配置
 */

// 保障计划详情
const protectionRule = () =>
  import(
    /* webpackChunkName: "protection-rule" */ '../views/cargo-treasure/protection-rule'
  );

// 服务协议页面
const serviceContractRule = () =>
  import(
  /* webpackChunkName: "service-contract-rule" */ '../views/cargo-treasure/service-contract-rule'
  );
// 常见问题
const commonProblem = () =>
  import(
  /* webpackChunkName: "common-problem" */ '../views/cargo-treasure/common-problem'
  );

export default [
  {
    name: 'cargoTreasureProtectionRule',
    path: '/cargo-treasure/protection-rule',
    component: protectionRule,
    meta: { title: '保险赠送详情' },
  },
  {
    name: 'cargoTreasureServiceContractRule',
    path: '/cargo-treasure/service-contract-rule',
    component: serviceContractRule,
    meta: { title: '服务协议' },
  },
  {
    name: 'cargoTreasureCommon-problem',
    path: '/cargo-treasure/common-problem',
    component: commonProblem,
    meta: { title: '常见问题' },
  }
];
